import { useAvailabilityFilter } from '@/components/search/searchFilters/availabilityFilter/useAvailabilityFilter'
import { useEstablishmentTypeFilter } from '@/components/search/searchFilters/establishmentTypeFilter/useEstablishmentTypeFilter'
import { usePricingFilter } from '@/components/search/searchFilters/pricingFilter/usePricingFilter'
import get from 'lodash/get'
import reject from 'lodash/reject'
import includes from 'lodash/includes'
import { GlobalSettingsEnum, servicesTemplateIdsToExcludeByFlagName } from '@/enums'
import { useSettingsStore } from '@/stores/settings'

export const useFilters = () => {
  /**
   * Some initializations
   */
  const establishmentTypeFilter = useEstablishmentTypeFilter()
  const pricingFilter = usePricingFilter()
  const availabilityFilter = useAvailabilityFilter()
  const settingsStore = useSettingsStore()

  /**
   * Applies filters on a place
   */
  const filterPlace = (place: any): boolean => {
    return establishmentTypeFilter.filter(place)
  }

  /**
   * Applies filters on the place's services
   */
  const filterPlaceServices = (services: any[]) => {
    return services.filter(
      (service) => pricingFilter.filter(service) && availabilityFilter.filter(service)
    )
  }

  const getAllServiceTemplateIdsToExclude = () => {
    const allServiceTemplateIdsToExclude = [
      ...(settingsStore.globalSettings[GlobalSettingsEnum.SERVICE_EXCLUSIONS]?.value ?? [])
    ]
    Object.keys(servicesTemplateIdsToExcludeByFlagName).forEach((flagName) => {
      if (settingsStore.globalSettings[flagName]?.value) {
        allServiceTemplateIdsToExclude.push(...servicesTemplateIdsToExcludeByFlagName[flagName])
      }
    })
    return allServiceTemplateIdsToExclude
  }

  const filteredServiceTemplates = (serviceTemplates: any[]) => {
    const allServiceTemplateIdsToExclude = getAllServiceTemplateIdsToExclude()
    return reject(serviceTemplates, (service) =>
      includes(allServiceTemplateIdsToExclude, get(service, 'serviceTemplateId', 0))
    )
  }

  return {
    filterPlace,
    filterPlaceServices,
    filteredServiceTemplates,
    getAllServiceTemplateIdsToExclude
  }
}
